import { FC } from "react"
import Dynamic from '@/lib/dynamic'
import ComponentSpinner from "@/components/ui/componentSpinner"
import { TabData } from "rc-dock"
import { TabTitle } from "@/chat2/components/chatlayout/TabTitle"

// ============================================================================
// DYNAMIC IMPORTS
// ============================================================================

const IntegrationInstanceTab = Dynamic(
  () => import("@/components/workspace/integrations/IntegrationInstanceTab").then(mod => ({ default: mod.IntegrationInstanceTab })),
  { ssr: false, loading: () => <ComponentSpinner /> }
)

// ============================================================================
// WRAPPER COMPONENTS
// ============================================================================

/** Common wrapper for integration tab content - enables scrolling within dock panel */
const IntegrationTabWrapper: FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="h-full flex flex-col overflow-hidden">{children}</div>
)

export const IntegrationTab: FC<{ tabId: string }> = ({ tabId }) => {
  // IntegrationInstanceTab expects id format "integration:uuid"
  // It splits on ":" internally to get the actual instance ID
  // setTabMetadata is called by IntegrationInstanceTab after instance loads
  return (
    <IntegrationTabWrapper>
      <IntegrationInstanceTab id={tabId} />
    </IntegrationTabWrapper>
  )
}

// ============================================================================
// RENDERERS
// ============================================================================

export const IntegrationTabRenderer = (id: string): TabData => ({
  id,
  title: <TabTitle id={id} />,
  content: <IntegrationTab tabId={id} />
})
